// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCU7RzVZdMa0-PCQZIT6xshV-Fv4OtRKLY",
  authDomain: "hamyap-ac6d7.firebaseapp.com",
  projectId: "hamyap-ac6d7",
  storageBucket: "hamyap-ac6d7.appspot.com",
  messagingSenderId: "680957392650",
  appId: "1:680957392650:web:efdef8c87b4060cd2bacf3",
  measurementId: "G-HPLFLFL28Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
const analytics = getAnalytics(app);